// @ts-nocheck
import React, { useRef, ReactNode } from 'react';
import clsx from 'clsx';
import useLockBodyScroll from 'components/hooks/useLockBodyScroll';
import { Portal } from 'react-portal';
import useOnClickOutside from 'components/hooks/useOnClickOutside';
import ModalWrapper from './ModalWrapper';

interface ModalProps {
  className?: string;
  children?: ReactNode;
  closed?: boolean;
  visible?: boolean;
  close?: () => void;
  closeButton?: ReactNode;
  closeIconInModal?: boolean;
  outerClassName?: string | null;
  dialogClassName?: string | null;
  closeOnClickOutside?: boolean;
}

const Modal: React.FC<ModalProps> = ({
  className = '',
  children,
  closed = true,
  visible,
  close,
  closeButton = '',
  closeIconInModal = false,
  outerClassName = null,
  dialogClassName = null,
  closeOnClickOutside = true,
}) => {
  useLockBodyScroll(visible);

  const ref = useRef<HTMLDivElement>(null);
  useOnClickOutside(ref, closeOnClickOutside ? close : () => undefined);

  return visible ? (
    <Portal>
      <ModalWrapper closeIconInModal={closeIconInModal} className={outerClassName} data-modal>
        <div
          role="dialog"
          aria-hidden={!visible}
          aria-labelledby="modal__title"
          ref={ref}
          className={clsx('dialog', dialogClassName)}
        >
          <div className={clsx('modal', className)}>
            {closeIconInModal && closed ? closeButton : null}
            {children}
          </div>

          {!closeIconInModal && closed ? closeButton : null}
        </div>
      </ModalWrapper>
    </Portal>
  ) : null;
};

export default Modal;
